import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { Modal } from "../Modal";
import { ModalProps } from "../../../pages/PortfolioGalary";
import { BaseButton } from "../../../atoms/BaseButton";

interface Props {
  modal: ModalProps;
  setModal: Dispatch<SetStateAction<ModalProps>>;
}

export const PhotoModal = ({ modal, setModal }: Props) => {
  if (!modal) {
    return;
  }

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setModal({ modal: "", data: "" });
    }
  };

  const onCloseClick = () => {
    setModal({ modal: "", data: "" });
  };

  const ref = useRef(null);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <Modal>
      <div className="m-auto flex h-5/6" ref={ref}>
        <div className="flex flex-col">
          <img
            src={modal.data}
            alt="gallery photo"
            className="flex h-full rounded"
            loading="lazy"
          />
          <BaseButton className="mx-auto mt-2 text-lg" onClick={onCloseClick}>
            Close
          </BaseButton>
        </div>
      </div>
    </Modal>
  );
};
